import React from "react";
import { Box, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";
import PartRow from "./PartRow";




function ViewPartsModal({open, setOpen, workLookup}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
          closeOnBlur
          active={open}
          onClick={e => {e.stopPropagation()}}
          onClose={() => {
            setOpen(false);
          }}
        >
            <Modal.Content className="wider-modal">
                <Section style={{ backgroundColor: "grey" }}>
                    <Box>
                        <Title>Parts</Title>
                        <Table isFullwidth>
                            <tr>
                                <th>Part Name</th>
                                <th>Part Number</th>
                                <th>Part Supplier</th>
                                <th>Part Cost</th>
                            </tr>
                            <tbody>
                                {workLookup ? workLookup.part_work_lookup.map((part, index) => (
                                    <PartRow
                                        workLookup={workLookup}
                                        index={index}
                                        disabled={true}
                                    />
                                )) : <tr></tr>}
                            </tbody>
                        </Table>
                    </Box>
                </Section>
            </Modal.Content>
        </Modal>
    );


}
export default ViewPartsModal;